﻿export enum MeasurementTableType {
    Section = "Section",
    Route = "Route"
}